/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import Question from '../components/Question'
import { withStyles } from '@material-ui/core/styles/index'
import { Box } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import QuestionPageFooter from './partials/QuestionPageFooter'
import QuestionPageHeader from './partials/QuestionPageHeader'
import AttentionElement from '../components/AttentionElement'
import validator from 'validator'
import parse from 'html-react-parser'
import ReactGA from 'react-ga'
import { styles } from './QuestionPage.styles'
import { dateRegex, phoneNumberRegex, bannedWords, postCodeRegex } from './InputValidation.const'
import QuestionPageStepper from './partials/QuestionPageStepper'
import Motivation from '../components/Motivation'
import ApplicationElement from '../components/ApplicationElement'
import { getValidateEmail } from '../../api'

import {
    Grid,
    Button,
    LinearProgress,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography
} from '@material-ui/core'
import Terms from './partials/Terms'
import HeaderImage from './partials/HeaderImage'
import queryString from 'query-string'

class QuestionPage extends PureComponent {
    constructor(props) {
        super(props)
        this.questionPageRef = React.createRef()
        this.autoRedirectTimeout = null
        this.luckyWheelRef = React.createRef()
    }

    state = {
        value: null,
        questionValues: [],
        validateOnInput: false,
        configrmationDialog: null,
        emailValidated: false,
        confirmAnswerValue: '',
        questionInConfirmation: null,
        emailValidationOneInvalid: false,
        showMotivation: true,
        isWheelInfoDialogOpen: false,
        wheelInfoDialogText: '',
        isCurrentWheelCompleted: false,
        isWheelSpinning: false
    }

    componentDidMount() {
        this.onQuestionPageChanged(this.props, true)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.questionPage.id !== this.props.questionPage.id) {
            this.onQuestionPageChanged(nextProps)
        }
    }

    onSubmit = (previous = false) => {
        if (this.state.isWheelSpinning) {
            // when wheel is spinning, don't submit
            return
        }
        const isCurrentPageLuckyWheel = this.containsLuckyWheel(this.props.questionPage)
        const isLuckyWheelCompleted = this.state.isCurrentWheelCompleted
        if (isCurrentPageLuckyWheel && !isLuckyWheelCompleted) {
            this.setState({ isWheelSpinning: true })
            this.luckyWheelRef?.current?.spin()
            return
        }

        if (this.props.questionPage.submitButton.url) {
            if (this.props.questionPage.submitButton.url === 'reload') {
                window.location.reload()
            } else {
                window.location = this.props.questionPage.submitButton.url
            }
            return
        }
        if (!previous) {
            const isAnswersValid = this.validateAnswers(true)
            if (isAnswersValid && !this.props.isLoading) {
                this.props.onSubmit(this.state.questionValues, previous)
                this.setState({ validateOnInput: false })
            } else {
                this.setState({ validateOnInput: true })
            }
        } else {
            this.props.onSubmit(this.state.questionValues, previous)
        }
        this.forceUpdate()
    }

    onQuestionPageChanged = (nextProps, isFirst = false) => {
        if (this.autoRedirectTimeout) {
            clearTimeout(this.autoRedirectTimeout)
        }

        let questionValues = []
        const questionPageElements = nextProps.questionPage && nextProps.questionPage.elements ? nextProps.questionPage.elements : []
        const parsedQueryString = queryString.parse(window.location.search)

        for (let question of questionPageElements) {
            if (question.value) {
                questionValues.push({ id: question.id, value: question.value })
            } else if (parsedQueryString && parsedQueryString[question.name]) {
                const value =
                    question.type === 'text' || question.type === 'email' || question.type === 'date'
                        ? parsedQueryString[question.name]
                        : question.options.find(option => option.label === parsedQueryString[question.name])?.id
                questionValues.push({ id: question.id, value: value })
            }
        }
        this.setState({ questionValues: questionValues, showMotivation: true })

        if (!isFirst) {
            this.scrollToStart()
        }

        if (nextProps) {
            if (nextProps.questionPage.autoRedirectIn && nextProps.questionPage.submitButton.url) {
                this.autoRedirectTimeout = setTimeout(() => {
                    this.onSubmit()
                }, nextProps.questionPage.autoRedirectIn * 1000)
            }
        }
    }

    isElementInView(element) {
        const bounding = element.getBoundingClientRect()
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    scrollToStart = () => {
        const element = document.getElementById('questionApplicationContent')
        if (!this.isElementInView(element)) {
            // Calculate target position with 8px offset from top
            const elementRect = element.getBoundingClientRect()
            const absoluteTop = elementRect.top + window.pageYOffset
            const offsetTop = absoluteTop - 16 // 8px extra space at top
            
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        }
    }

    checkAutoSubmit = () => {
        if (!this.props.questionPage.autoSubmit || this.props.isLoading) {
            return false
        }
        const questions = this.props.questionPage.elements.filter(x => x.elementType === 'question')
        const questionValues = this.state.questionValues
        for (let question of questions) {
            if (questionValues.findIndex(x => x.id === question.id) < 0) {
                return false
            }
        }
        return true
    }

    validateAnswers = onSubmit => {
        let valid = true
        const questions = this.props.questionPage.elements.filter(x => x.elementType === 'question')
        for (let question of questions) {
            let errorMessage = this.isAnswerValid(question, onSubmit)
            if (errorMessage !== null) {
                if (errorMessage === 'waiting') {
                    valid = false
                    question.valid = false
                    question.errorMessage = ''
                    question.waitingValidation = true
                } else {
                    valid = false
                    question.valid = false
                    question.errorMessage = errorMessage
                }
            } else {
                question.valid = true
            }
        }
        return valid
    }

    isAnswerValid(question, onSubmit) {
        const validationStr = question.validation
        if (!validationStr) {
            return null
        }
        const validationArr = validationStr.split('|')
        const answer = this.state.questionValues.find(x => x.id === question.id)
        for (let validationType of validationArr) {
            if (validationType === 'required') {
                if (!answer || !answer.value || answer?.value.length === 0) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Svar på dette igen'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Svara på detta'
                    }
                    return 'Vastaa vielä tähän'
                }
            }
            if (validationType.substring(0, 5) === 'size:') {
                let value = parseInt(validationType.substring(5))
                if (!answer || answer.value.length < value) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Vastaus on liian lyhyt'
                }
            }
            if (validationType === 'noBannedWords') {
                for (let bannedWord of bannedWords) {
                    if (!answer || answer.value.toLowerCase().indexOf(bannedWord) !== -1) {
                        if (process.env.MIX_APP_COUNTRY === 'denmark') {
                            return 'Tjek det her'
                        }
                        if (process.env.MIX_APP_COUNTRY === 'sweden') {
                            return 'Ogiltigt'
                        }
                        return 'Vastaus ei ole kelvollinen'
                    }
                }
            }
            if (validationType === 'email') {
                if (!answer || !validator.isEmail(answer.value)) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Sähköpostiosoite ei ole kelvollinen'
                } else if (validator.isEmail(answer.value)) {
                    if (!this.state.emailValidated && onSubmit) {
                        this.onValidateEmail(question, answer.value)
                        return 'waiting'
                    }
                }
            }
            if (validationType === 'date') {
                if (!answer || !dateRegex.test(answer.value)) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Päivämäärä ei kelpaa'
                }
            }
            if (validationType === 'phonenumber') {
                let phoneNumberRegexResult = phoneNumberRegex.test(answer.value)
                if (!answer || !phoneNumberRegexResult) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Puhelinnumero ei kelpaa'
                }
            }
            if (validationType === 'postcode') {
                if (!answer || !postCodeRegex.test(answer.value)) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Postinumero ei kelpaa'
                }
            }
            if (validationType === 'y-tunnus') {
                if (!answer || answer.value.length !== 9) {
                    return 'Väärän pituinen Y-tunnus'
                }
                const yTunnus = answer.value
                const yTunnusSum =
                    7 * yTunnus[0] + 9 * yTunnus[1] + 10 * yTunnus[2] + 5 * yTunnus[3] + 8 * yTunnus[4] + 4 * yTunnus[5] + 2 * yTunnus[6]
                const yTunnusMod = yTunnusSum % 11
                const yTunnusCheckSum = yTunnusMod === 0 ? 0 : 11 - yTunnusMod

                if (Number(yTunnusCheckSum) !== Number(yTunnus[8])) {
                    return 'Viallinen Y-tunnus'
                }
            }
        }
        return null
    }

    onValidateEmail = (question, email) => {
        getValidateEmail(email).then(data => {
            question.waitingValidation = false
            if (data.error === true) {
                ReactGA.event({
                    category: 'EmailValidation',
                    action: 'Error'
                })
                this.setEmailValidated(question)
            } else {
                const sendex = data.sendex
                if (sendex >= 0.7) {
                    ReactGA.event({
                        category: 'EmailValidation',
                        action: 'Confirmed'
                    })
                    this.setEmailValidated(question)
                } else if (this.state.emailValidationOneInvalid === true) {
                    ReactGA.event({
                        category: 'EmailValidation',
                        action: 'LetThroughAfterOneInvalid'
                    })
                    this.setEmailValidated(question)
                } else {
                    ReactGA.event({
                        category: 'EmailValidation',
                        action: 'Not Confirmed'
                    })
                    const confirmationDialog = {
                        open: true,
                        title: 'Varmista sähköpostiosoitteesi',
                        description:
                            'Huomasimme, että sähköpostiosoitteesi <b>' +
                            email +
                            '</b> saattaa olla virheellinen. Vahvistathan osoitteesi tai käytä toista sähköpostiosoitetta.'
                    }
                    this.setState({
                        confirmationDialog: confirmationDialog,
                        confirmAnswerValue: '',
                        questionInConfirmation: question,
                        emailValidationOneInvalid: true
                    })
                }
            }
        })
    }

    onConfirmationDialogClose = () => {
        const question = this.state.questionInConfirmation
        const value = this.state.confirmAnswerValue
        this.onQuestionValueChanged(question.id, value, this)
        this.setState({
            confirmationDialog: null,
            confirmAnswerValue: '',
            questionInConfirmation: null
        })
    }

    onConfirmAnswerValueChanged = event => {
        this.setState({ confirmAnswerValue: event.target.value })
    }

    setEmailValidated = question => {
        question.waitingValidation = false
        this.setState({ emailValidated: true }, () => {
            this.onSubmit()
        })
    }

    onQuestionValueChanged = (id, value, validate = true) => {
        let questionValues = this.state.questionValues
        let questionIndex = questionValues.findIndex(x => x.id === id)
        if (questionIndex < 0) {
            const questionValue = { id: id, value: value }
            questionValues.push(questionValue)
        } else {
            questionValues[questionIndex].value = value
        }
        this.setState({ questionValues: questionValues })
        const submit = this.checkAutoSubmit()
        if (submit) {
            this.onSubmit()
        }
        if (validate && this.state.validateOnInput) {
            this.validateAnswers(false)
        }
        this.forceUpdate()
    }

    hideMotivation = () => {
        this.setState({
            showMotivation: null
        })
    }

    containsLuckyWheel = questionPage => {
        if (!questionPage.elements || !Array.isArray(questionPage.elements)) {
            return false
        }

        for (let element of questionPage.elements) {
            if (element.type === 'lucky wheel') {
                return true
            }
        }
        return false
    }

    handleSpinComplete = (landedSector, question) => {
        this.setState({ isWheelSpinning: false })

        if (landedSector === 'spin_again') {
            console.log('landedSector.action === spin_again')
            this.setState({ isWheelInfoDialogOpen: true, wheelInfoDialogText: 'Olet voittanut uuden pyöräytyksen!' })
        } else if (landedSector === 'no_prize') {
            this.setState({
                isWheelInfoDialogOpen: true,
                wheelInfoDialogText: 'Et voittanut tällä kertaa mutta jatka vastailua niin voit saada uuden pyöräytyksen!',
                isCurrentWheelCompleted: true
            })
            this.onQuestionValueChanged(question.id, question.options[0].value)
        } else if (landedSector === 'secondary_prize') {
            // TODO: Add secondary prize logic
        } else if (landedSector === 'primary_price') {
            // TODO: Add primary prize logic
        }
    }

    render() {
        const { classes, questionPage, isLoading, alias, visitorSessionId, theme, layout, prelanderAnswers, isPreview } = this.props
        const questionValues = this.state.questionValues

        const headerImagePositionInCard = !(layout === 'exclusive' || layout === 'premium-exclusive')

        return (
            <div
                ref={this.questionPageRef}
                id={'app-question-page-' + alias}
                className={'QuestionPageWrapper app-question-page-id-' + questionPage.id + ' ' + classes.root}
            >
                {questionPage.progressPosition === 'header' && (
                    <LinearProgress variant="determinate" value={questionPage.progress} className="progressBar" />
                )}
                {headerImagePositionInCard && theme?.headerImage && !isPreview && <HeaderImage theme={theme} questionPage={questionPage} />}
                {Boolean(questionPage.isSignupPage) && prelanderAnswers && prelanderAnswers.length > 0 && (
                    <Box className={classes.prelanderAnswerWrapper + ' prelanderAnswerWrapper'}>
                        {prelanderAnswers.map((answer, index) => (
                            <Box className={classes.prelanderAnswer} key={index}>
                                {answer}
                            </Box>
                        ))}
                        {questionPage.prelanderCompletedMessage && (
                            <div className={'prelander-completed-message-wrapper ' + classes.prelanderCompletedMessageWrapper}>
                                <Typography component="div" variant="body1" align="center" color="textSecondary" id={'prelander-completed-message'}>
                                    {parse(questionPage.prelanderCompletedMessage)}
                                </Typography>
                            </div>
                        )}
                    </Box>
                )}
                <div id="questionApplicationContent" className={classes.questionApplicationContent}>
                    {questionPage.showHeader && (
                        <QuestionPageHeader questionPage={questionPage} theme={theme} layout={layout} isPreview={isPreview} />
                    )}
                    {!(questionPage.motivationText && this.state.showMotivation) && (
                        <>
                            <Grid
                                container
                                spacing={2}
                                classes={{ item: classes.questionContainer + ' question-container' }}
                                className={classes.questionWrapper}
                                item={true}
                            >
                                {layout === 'full' && Boolean(questionPage.isSignupPage) && (
                                    <div className={'signup-label'}>Yhteystiedot osallistumista varten</div>
                                )}
                                {questionPage.elements.map((element, key) => {
                                    const questionValue = questionValues.find(x => x.id === element.id)
                                    const value = questionValue ? questionValue.value : null

                                    return (
                                        <React.Fragment key={key}>
                                            {element.elementType === 'question' && (
                                                <Question
                                                    question={element}
                                                    value={value}
                                                    onValueChanged={this.onQuestionValueChanged}
                                                    visitorSessionId={visitorSessionId}
                                                    theme={theme}
                                                    layout={layout}
                                                    isSignupPage={Boolean(questionPage.isSignupPage)}
                                                    campaignId={questionPage.campaign_id}
                                                    luckyWheelRef={this.luckyWheelRef}
                                                    luckyWheelOnSpinComplete={this.handleSpinComplete}
                                                />
                                            )}
                                            {element.elementType === 'attentionElement' && <AttentionElement element={element} />}
                                            {element.elementType === 'applicationElement' && <ApplicationElement element={element} />}
                                        </React.Fragment>
                                    )
                                })}
                                {questionPage.image && (
                                    <div className={classes.imageWrapper}>
                                        <img src={questionPage.image} className={classes.image} />
                                    </div>
                                )}
                            </Grid>
                            {questionPage.submitButton.show && questionPage.submitButton.position === 'footer' && (
                                <Grid item xs={12} sm={12} className={classes.buttons + ' question-page-navigation'} key={'button'}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={classes.button + ' forwardButton ' + (questionPage.id === -1 ? classes.completedPageButton : '')}
                                        onClick={() => this.onSubmit()}
                                        disabled={isLoading}
                                        style={layout === 'full' ? {
                                            fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            padding: '12px 28px',
                                            borderRadius: 14,
                                            background: 'linear-gradient(135deg, #205a40 0%, #2d7a58 100%)',
                                            boxShadow: '0 4px 16px rgba(32, 90, 64, 0.3)',
                                        } : undefined}
                                    >
                                        {alias === 'yhteystietosivu1' ? 'Jatka' : questionPage.submitButton.label}
                                        {!isLoading && (
                                            <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', questionPage.submitButton.icon]} />
                                        )}
                                        {isLoading && (
                                            <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'spinner-third']} spin />
                                        )}
                                    </Button>
                                </Grid>
                            )}
                            {questionPage.stepper && questionPage.stepper.place === 'footer' && (
                                <Grid item xs={12} sm={12} key={'footer-stepper'} style={{ padding: 0 }}>
                                    <QuestionPageStepper stepper={questionPage.stepper} />
                                </Grid>
                            )}
                            {questionPage.footerText && (
                                <div className={'question-page-footer-text-wrapper ' + classes.questionPageFooterTextWrapper}>
                                    <Typography component="div" variant="body1" align="center" color="textSecondary" id={'question-page-footer-text'}>
                                        {parse(questionPage.footerText)}
                                    </Typography>
                                </div>
                            )}
                            {questionPage.showFooter && <QuestionPageFooter layout={layout} />}
                            {questionPage.progressPosition === 'footer' && questionPage.progress !== 100 && (
                                <LinearProgress
                                    variant="determinate"
                                    value={questionPage.progress}
                                    className={'progressBar ' + classes.footerProgressBar}
                                />
                            )}
                            {questionPage && questionPage.termsPosition === 'footer' ? (
                                <Terms domain={questionPage.domain} theme={theme} layout={layout} />
                            ) : (
                                <Box mt={{ xs: 1, sm: 3 }} />
                            )}
                        </>
                    )}
                    <Dialog open={this.state.isWheelInfoDialogOpen} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{'Onnea!'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">{this.state.wheelInfoDialogText}</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={e => this.setState({ isWheelInfoDialogOpen: false })} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>

                {this.state.confirmationDialog && (
                    <Dialog
                        classes={{
                            root: classes.dialog
                        }}
                        className="dialog"
                        open={this.state.confirmationDialog.open}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle disableTypography>
                            <Typography variant={'h5'} className={classes.dialogTitle}>
                                {this.state.confirmationDialog.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>{parse(this.state.confirmationDialog.description)}</DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="email"
                                label="Sähköpostiosoite"
                                type="email"
                                onChange={this.onConfirmAnswerValueChanged}
                                value={this.state.confirmAnswerValue}
                                style={{ padding: '6 0 7px' }}
                                fullWidth
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onConfirmationDialogClose} color="primary" disabled={this.state.confirmAnswerValue === ''}>
                                Jatka
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}

                {questionPage.motivationText && this.state.showMotivation && (
                    <Motivation
                        text={questionPage.motivationText}
                        url={questionPage.motivationUrl}
                        buttonText={questionPage.motivationButtonText}
                        onClose={this.hideMotivation}
                    />
                )}
            </div>
        )
    }
}

export default withStyles(styles)(QuestionPage)
